<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div class="me-2 mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-white d-inline-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#section_csv_import_modal"
              v-can="'Section.Create'"
            >
              <i class="ti ti-file-import me-1"></i>Import
            </a>
          </div>
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#add_section"
              class="btn btn-primary d-flex align-items-center"
              v-can="'Section.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Section
            </a>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <h5>Section List</h5>
          <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ departmentLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="clearDepartment">
                    All Departments
                  </a>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li v-for="dept in departmentOptions" :key="dept.id">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="changeDepartment(dept.id)"
                  >
                    {{ dept.name }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ statusLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="changeStatus('Active')">Active</a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="changeStatus('Inactive')">Inactive</a>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="changeStatus('')">All Statuses</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="data"
              :loading="loading"
              row-key="id"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Status'">
                  <span
                    :class="[
                      'badge',
                      record.Status === 'Active' ? 'badge-success' : 'badge-danger',
                      'badge-xs',
                    ]"
                  >
                    <i class="ti ti-point-filled me-1"></i>{{ record.Status }}
                  </span>
                </template>
                <template v-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_section"
                      @click="openEdit(record)"
                      v-can="'Section.Edit'"
                    >
                      <i class="ti ti-edit"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_section_modal"
                      @click="openDelete(record)"
                      v-can="'Section.Delete'"
                    >
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <SectionModal ref="sectionModal" @refresh="fetchSections" />
  <CsvImportModal
    modal-id="section_csv_import_modal"
    title="Import Sections from CSV"
    description="Upload a CSV to create sections. Department names must already exist (import departments first). Leave empty if your company does not use sections."
    template-hint="Columns: Name, Department, Status (Active/Inactive)."
    template-filename="section-import-template.csv"
    :columns="importColumns"
    :download-template-fn="downloadSectionTemplate"
    :preview-fn="previewSectionImport"
    :apply-fn="applySectionImport"
    @imported="onSectionsImported"
  />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useSectionStore } from "@/stores/sectionStore";
import { useDepartmentStore } from "@/stores/departmentStore";
import SectionModal from "@/components/modal/section-modal.vue";
import CsvImportModal from "@/components/modal/csv-import-modal.vue";
import sectionService from "@/services/hrm/sectionService";

const title = "Employees";
const text = "Employees";
const text1 = "Sections";

const importColumns = [
  { key: "line", title: "Line" },
  { key: "name", title: "Section" },
  { key: "department", title: "Department" },
  { key: "new_status", title: "Status" },
];

function downloadSectionTemplate() {
  return sectionService.downloadImportTemplate();
}
function previewSectionImport(file, mode) {
  return sectionService.previewImport(file, mode);
}
function applySectionImport(file, mode) {
  return sectionService.applyImport(file, mode);
}
function onSectionsImported() {
  fetchSections();
}

const columns = [
  { title: "Section", dataIndex: "Section", key: "Section" },
  { title: "Department", dataIndex: "Department" },
  { title: "Employees", dataIndex: "NoofEmployees" },
  { title: "Designations", dataIndex: "NoofDesignations" },
  { title: "Status", dataIndex: "Status", key: "Status" },
  { title: "", key: "action" },
];

const sectionStore = useSectionStore();
const departmentStore = useDepartmentStore();
const sectionModal = ref(null);
const loading = computed(() => sectionStore.loading);

const filters = ref({
  department_id: "",
  status: "",
});

const departmentOptions = computed(() => departmentStore.departments || []);
const departmentLabel = computed(() => {
  if (!filters.value.department_id) return "Department";
  const d = departmentOptions.value.find((x) => Number(x.id) === Number(filters.value.department_id));
  return d?.name || "Department";
});
const statusLabel = computed(() => filters.value.status || "Select Status");

const data = computed(() =>
  (sectionStore.sections || []).map((s) => ({
    id: s.id,
    key: s.id,
    Section: s.name,
    Department: s.department?.name || "",
    department_id: s.department_id,
    NoofEmployees: s.employees_count ?? 0,
    NoofDesignations: s.designations_count ?? 0,
    Status: s.status,
  })),
);

async function fetchSections() {
  const params = {};
  if (filters.value.department_id) params.department_id = filters.value.department_id;
  if (filters.value.status) params.status = filters.value.status;
  await sectionStore.fetchSections({ ...params, force: true });
}

function changeDepartment(id) {
  filters.value.department_id = id;
  fetchSections();
}
function clearDepartment() {
  filters.value.department_id = "";
  fetchSections();
}
function changeStatus(status) {
  filters.value.status = status;
  fetchSections();
}
function openEdit(record) {
  sectionModal.value?.openEditModal(record);
}
function openDelete(record) {
  sectionModal.value?.openDeleteModal(record);
}

onMounted(async () => {
  if (!departmentStore.departments.length) await departmentStore.ensureDepartments();
  await fetchSections();
});
</script>
